<template>
  <button
    class="control-button"
    @click="player.togglePanel(PanelType.CHAPTERS)"
    :aria-label="t('player.controls.chapters')"
    :data-tooltip="t('player.controls.chapters')"
    :aria-expanded="player.activePanel.value === PanelType.CHAPTERS"
    v-html="chaptersIcon"
  />
</template>

<script setup lang="ts">
import { chaptersIcon } from '../../assets/icons'
import { PanelType } from '../../types'
import { useVideoI18n } from '../../i18n'
import type { UseVideoPlayerReturn } from '../../composables/useVideoPlayer'

defineProps<{
  player: UseVideoPlayerReturn
}>()

const { t } = useVideoI18n()
</script>

<style scoped>
/* Styles are in main.scss */
</style>
